import './index.scss';
import React, { forwardRef } from 'react';
import Button from '~/components/button';
import { SearchType } from '~/routes/content_library/providers/enums';
import AdvancedClauseSearch from './advanced_clause_search';
import AdvancedDocumentSearch from './advanced_document_search';
const AdvancedSearchDialog = forwardRef(({ search, advancedFilters, setAdvancedFilters, close, searchType, clearFilters, }, ref) => {
    return (React.createElement("div", { className: 'advanced-search-dialog', ref: ref },
        React.createElement("div", { className: 'search-fields' },
            searchType === SearchType.Clauses &&
                React.createElement(AdvancedClauseSearch, { advancedFilters: advancedFilters, setAdvancedFilters: setAdvancedFilters }),
            searchType === SearchType.Documents &&
                React.createElement(AdvancedDocumentSearch, { advancedFilters: advancedFilters, setAdvancedFilters: setAdvancedFilters })),
        React.createElement("div", { className: 'advanced-search-group submit' },
            React.createElement(Button, { "data-testid": 'search-clear-button', className: 'clear-btn', secondary: true, onClick: () => clearFilters() }, "Clear"),
            React.createElement(Button, { "data-testid": 'search-execute-button', onClick: () => {
                    search();
                    close();
                } }, "Search"))));
});
export default AdvancedSearchDialog;
